module.exports = __webpack_public_path__ + "static/media/Resume_Aman_Khandelwal.93443c97.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Resume_Aman_Khandelwal.pdf
// module id = 33
// module chunks = 0